import { DeliveryMode, OrderMethod } from '../../../../../../../services/exports/Constants';

export default {
  title: 'Tager ordren længere/kortere tid?',
  text: {
    [OrderMethod.Pickup]:
      'Kunden forventer, at ordren er klar til afhentning <strong>{{date}}</strong> kl. <strong>{{time}}</strong><br/> Om nødvendigt kan du ændre tidspunktet her.',
    [OrderMethod.OnSite]:
      'Kunden forventer bestillingen ved <strong>{{table}}</strong><br/><strong>{{date}}</strong> kl. <strong>{{time}}</strong><br/> Om nødvendigt kan du ændre tidspunktet her.',
    // A table order whose table the backend could not name.
    on_site_without_table:
      'Kunden forventer ordren ved bordet <strong>{{date}}</strong> kl. <strong>{{time}}</strong><br/> Om nødvendigt kan du ændre tidspunktet her.',
    [OrderMethod.Delivery]: {
      [DeliveryMode.Internal]:
        'Kunden forventer, at ordren leveres <strong>{{date}}</strong> kl. <strong>{{time}}</strong><br/> Om nødvendigt kan du ændre tidspunktet her.',
      [DeliveryMode.External]:
        'Chaufføren ankommer for at hente ordren kl. <strong>{{time}}{{confidenceLabel}}</strong>',
    },
  },
  labels: {
    today: 'I dag',
  },
  confidence_labels: {
    estimated: ' (anslået!)',
    confirmed: '',
  },
  buttons: {
    confirm_pickup: 'Bekræft ny afhentningstid',
    confirm_on_site: 'Bekræft ny serveringstid',
    confirm_delivery: 'Bekræft ny leveringstid',
  },
  confirmation_modal: {
    description: 'Er du sikker på, at du vil ændre tidspunktet fra {{currentPickupTime}} til {{newPickupTime}}?',
    ok_button_text: 'Bekræft ny tid',
    cancel_button_text: 'Nej, behold oprindelig tid',
  },
};
